import styled from "styled-components"

export const MedicationPageWrapper = styled.div``
